import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { waverlyConfig } from "./data";

export default function WaverlyPage() {
  return <CityPageTemplate config={waverlyConfig} />;
}